import { ChevronDownIcon } from '@/components/Icons';
import { Feature } from '@/config/featureFlags.definition';
import { isFeatureEnabled } from '@/config/featureFlags.service';
import { IGetXeroTenantResponse } from '@/services/types/Xero';
import { homePage, sideNav } from '@/utils/translations';
import React, { useState } from 'react';

interface SettingsMenuProps {
  showNavBarMenu?: string;
  onOpenNavigation: (menu: string) => void;
  onOpenGeneralLedgerPage: () => void;
  onOpenTeamMembers: () => void;
  onOpenCards: () => void;
  onCloseMenu: () => void;
  xeroTenant?: IGetXeroTenantResponse;
  onOpenXeroModal: () => void;
}

export const SettingsMenu: React.FC<SettingsMenuProps> = ({
  showNavBarMenu,
  onOpenNavigation: handleNavBarMenuDropdown,
  onOpenGeneralLedgerPage,
  onOpenTeamMembers,
  onOpenCards,
  onCloseMenu,
  onOpenXeroModal,
  xeroTenant
}) => {
  const [hoveredIdx, setHoveredIdx] = useState<number | null>(null);

  return (
    <div
      className="flex text-xs leading-6 gap-x-[5px] items-center relative cursor-pointer"
      onClick={() => handleNavBarMenuDropdown('settings')}>
      Settings
      <ChevronDownIcon size="xxs" className={showNavBarMenu === 'settings' ? 'rotate-180' : ''} />
      {showNavBarMenu === 'settings' ? (
        <div
          className="absolute top-6 w-44 bg-white text-emerge-navy z-50 rounded-md shadow-md -left-0"
          style={{
            width: '224px',
            maxHeight: '240px',
            overflowY: 'auto',
            boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.08)',
            borderRadius: '6px'
          }}
          onMouseLeave={onCloseMenu}>
          {/* Team members row */}
          {isFeatureEnabled(Feature.TEAM_MEMBERS) && (
            <div
              className="flex flex-col cursor-pointer bg-white p-4 hover:bg-emerge-base-2"
              onMouseEnter={() => setHoveredIdx(2)}
              onMouseLeave={() => setHoveredIdx(null)}
              onClick={onOpenTeamMembers}>
              <span className="text-emerge-navy-2 text-xs">{sideNav.teamMembers}</span>
            </div>
          )}
          {/* Cards row */}
          {isFeatureEnabled(Feature.CARDS) && (
            <div
              className="flex flex-col cursor-pointer bg-white p-4 hover:bg-emerge-base-2"
              onMouseEnter={() => setHoveredIdx(3)}
              onMouseLeave={() => setHoveredIdx(null)}
              onClick={onOpenCards}>
              <span className="text-emerge-navy-2 text-xs">{sideNav.cards}</span>
            </div>
          )}
          {/* General Ledger row */}
          <div
            className="flex flex-col p-4 cursor-pointer"
            style={{ background: hoveredIdx === 0 ? '#F7F7F2' : '#FFFFFF' }}
            onMouseEnter={() => setHoveredIdx(0)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={onOpenGeneralLedgerPage}>
            <span className="text-emerge-navy-2 text-xs">General Ledger settings</span>
          </div>
          {/* Xero row */}
          <div
            className="flex flex-col p-4 cursor-pointer"
            style={{ background: hoveredIdx === 1 ? '#F7F7F2' : '#FFFFFF' }}
            onMouseEnter={() => setHoveredIdx(1)}
            onMouseLeave={() => setHoveredIdx(null)}
            onClick={onOpenXeroModal}>
            <span className="text-emerge-navy-2 text-xs">
              {xeroTenant ? 'View Xero connections' : <>{homePage.xeroButton}</>}
            </span>
          </div>
        </div>
      ) : null}
    </div>
  );
};
